import { Outlet, useParams } from "react-router-dom";
import Navbar from "./components/Navbar";
import GetStartedModal from "../ui/GetStartedModal";
import { useEffect, useMemo, useState } from "react";
import InviteTeamMember from "@/components/ui/InviteTeamMember";
import Modal from "@/components/ui/Modal"; //
import { useGetTeamDataQuery } from "@/redux/feature/invite/inviteApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { setSelectedTeam } from "@/redux/feature/global/globalSlice";
import { stat } from "fs";
import { useCheckFeatureApprovedQuery } from "@/redux/feature/featureFlag/featureFlagApi";
import {
  desktopHeaderRoutes,
  FeatureFlagsConstants,
  hideMobileBottomNavRoutes,
  hideSideBarRoutes,
  mobileHeaderRoutes,
  orderButtonRoutes,
} from "@/constant";
// import AuthenticateProvider from "@/routes/AuthenticateProvIDer";

import { isCurrentRoute } from "@/utils/isCurrentRoute";
import { setExpanded } from "@/redux/feature/sidebar/sidebarSlice";
import SideBar from "./components/sideBar";
import MobileSideBar from "./components/mobileSideBar";
import Header from "./components/header";
import { useGetBrandDetailsQuery } from "@/redux/feature/videoDashboard/VideoDashboardApi";

const AiMarketplaceLayout = () => {
  const [isGetStartedModalOpen, setIsGetStartedModalOpen] = useState(false);
  const [isInviteModalOpen, setInviteModalOpen] = useState(false);
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const pathname = location.pathname;
  const { id: orderId } = useParams();

  const currentRoute = useMemo(() => {
    return pathname
      .split("/")
      .slice(0, 4)
      .join("/")
      .split(`${orderId}`)
      .join("")
      .replace(/\/$/, "");
  }, [pathname, orderId]);
  const isExpanded = useAppSelector((state) => state.sidebar.isExpanded);
  const [ShowCreateProjectModal, setShowCreateProjectModal] = useState(false);
  const [isIntelligenceModalOpen, setIsIntelligenceModalOpen] = useState(false);
  const [showJoinWaitListPopUp, setShowJoinWaitListPopUp] = useState(false);

  // Use the utility function to check the routes
  const showOrderButton = isCurrentRoute(currentRoute, orderButtonRoutes);
  const showDesktopHeader = isCurrentRoute(currentRoute, desktopHeaderRoutes);
  const showMobileHeader = isCurrentRoute(currentRoute, mobileHeaderRoutes);
  const showMobileBottomNav = isCurrentRoute(
    currentRoute,
    hideMobileBottomNavRoutes
  );
  const hideSidebar = isCurrentRoute(currentRoute, hideSideBarRoutes);
  const teamId = localStorage.getItem("teamId");

  const {
    data: teamDetails,
    isSuccess,
    isLoading: isTeamDataLoading,
  } = useGetTeamDataQuery(teamId, {
    skip: !teamId,
  });
  const { data: feature, isLoading: IsFeatureLoading } =
    useCheckFeatureApprovedQuery(
      {
        email: encodeURIComponent(user?.email as string),
        featureKey: FeatureFlagsConstants.AI_MARKET_PLACE,
      },
      {
        skip: !user?.email,
      }
    );

  const isApproved = feature?.data?.approved;
  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;

  const { data: brandDetails, isLoading } = useGetBrandDetailsQuery(
    user?.email
  );

  useEffect(() => {
    // Wait until all required data has finished loading
    if (isTeamDataLoading || IsFeatureLoading || isLoading) return;

    const hasTeam = !!teamDetails?.data?.team;

    // Case 1: If team exists, set it
    if (hasTeam) {
      dispatch(setSelectedTeam(teamDetails.data.team));
    }

    // Case 2: If no team AND feature not approved, redirect
    // if (!hasTeam && isApproved === false) {
    //   window.location.href = `${client_dashboard_baseUrl}/auth/sign-in`;
    // }

    // Case 3: Show Get Started modal if brand details missing
    if (brandDetails && !brandDetails.hasDetails) {
      setIsGetStartedModalOpen(true);
    }
  }, [
    isTeamDataLoading,
    IsFeatureLoading,
    isLoading,
    teamDetails,
    isApproved,
    brandDetails,
    dispatch,
    client_dashboard_baseUrl,
  ]);

  return (
    <div className="flex relative">
      {!hideSidebar && (
        <div
          onMouseEnter={() => dispatch(setExpanded(true))}
          onMouseLeave={() => dispatch(setExpanded(false))}
          className={`${
            isExpanded ? "w-[206px]" : "w-[76px]"
          } border-r border-[#F0F0F3] transform md:block hidden duration-300 ease-in-out transition-all `}
        >
          <SideBar
            isIntelligenceModalOpen={isIntelligenceModalOpen}
            setIsIntelligenceModalOpen={setIsIntelligenceModalOpen}
            isExpanded={isExpanded}
            setExpanded={setExpanded}
          />
        </div>
      )}
      <div className="md:hidden block">
        <MobileSideBar
          isIntelligenceModalOpen={isIntelligenceModalOpen}
          setIsIntelligenceModalOpen={setIsIntelligenceModalOpen}
        />
      </div>

      <div className="w-full pl-0 h-screen overflow-y-auto md:pb-0 relative">
        <Header setInviteModalOpen={setInviteModalOpen} />
        {/* <Navbar setInviteModalOpen={setInviteModalOpen} /> */}
        <div className="mx-auto my-3 lg:mb-10 px-6 lg:px-8 max-w-[1540px] md:mt-10">
          <Outlet />
        </div>

        {!isLoading && !brandDetails?.hasDetails && (
          <Modal
            isOpen={isGetStartedModalOpen}
            setOpen={setIsGetStartedModalOpen}
            width="500px"
          >
            <GetStartedModal setOpen={setIsGetStartedModalOpen} />
          </Modal>
        )}
        {isInviteModalOpen && (
          <Modal
            preventCloseOnClickOutside
            isOpen={isInviteModalOpen}
            setOpen={setInviteModalOpen}
          >
            <InviteTeamMember setOpen={setInviteModalOpen} />
          </Modal>
        )}
      </div>
    </div>
  );
};

export default AiMarketplaceLayout;
